import type {FileModel} from '../../domain/File/File.model';

export abstract class FileConvertWsService {
  abstract registerFileToConvert(file: FileModel): void;
}
